/**
 * Card Image Quick Add
 * Handles AJAX cart adds from the image overlay button on product cards.
 * Loaded globally so it works on the PLP, tabbed carousel, and any other
 * section that uses card-product.liquid.
 *
 * Single-variant: AJAX add to cart with visual feedback.
 * Multi-variant:  link navigates to PDP (no JS needed).
 * Fallback:       if fetch fails, falls back to standard form POST.
 */

(function () {
  // Event delegation — handles dynamically rendered cards (e.g. after AJAX filter)
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.classList.contains('card__image-quick-add-form')) return;

    e.preventDefault();

    const btn = form.querySelector('.card__image-quick-add-btn');
    const label = form.querySelector('.card__image-quick-add-label');
    const variantId = form.querySelector('[name="id"]')?.value;

    if (!variantId) return;

    const originalLabel = label ? label.textContent : '';

    btn.disabled = true;
    if (label) label.textContent = '…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });

      if (!res.ok) throw new Error('Cart add failed');

      // Visual confirmation
      btn.classList.add('is-added');
      if (label) label.textContent = 'Added!';

      // Notify Dawn's cart bubble / cart drawer if present
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } })
      );

      // Shopify's native cart count update event (works with most cart apps)
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      setTimeout(() => {
        btn.disabled = false;
        btn.classList.remove('is-added');
        if (label) label.textContent = originalLabel;
      }, 2000);

    } catch {
      // Fallback: standard form POST → goes to cart page
      btn.disabled = false;
      if (label) label.textContent = originalLabel;
      form.submit();
    }
  });
})();
